import React from 'react';
import 'devextreme-react/text-area';
import './style.scss';

export default function Forms() {
  return (
    <div className="form-readonly form-2-columns">
      <div className="form-col">
        <div className="form-group">
          <div className="form-label">National</div>
          <div className="form-value"><span>*****</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Citizen ID No</div>
          <div className="form-value"><span>038182006441</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Citizen Expired Date 1st</div>
          <div className="form-value"><span>3/20/2015</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">ID No</div>
          <div className="form-value"><span>2453534536456</span></div>
        </div>
      </div>
      <div className="form-col">
        <div className="form-group">
          <div className="form-label">Home Town</div>
          <div className="form-value"><span>*****</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Email</div>
          <div className="form-value"><span>phudt@nec.vn</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Citizen ID Issue Date</div>
          <div className="form-value"><span>17/11/2017</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Citizen Expired Date 2nd</div>
          <div className="form-value"><span>3/20/2030</span></div>
        </div>
      </div>
      <div className="form-col">
        <div className="form-group">
          <div className="form-label">ID Issue Date</div>
          <div className="form-value"><span>-</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Hometown District</div>
          <div className="form-value"><span>*****</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Phone Number</div>
          <div className="form-value"><span>0902280525</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Citizen ID Issue Place</div>
          <div className="form-value"><span>Cục quản lý xuất nhập cảnh</span></div>
        </div>
      </div>
      <div className="form-col">
        <div className="form-group">
          <div className="form-label">Citizen Expired Date 3rd</div>
          <div className="form-value"><span>3/20/2050</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">ID Issue Place</div>
          <div className="form-value"><span>Tay Ninh</span></div>
        </div>
        <div className="form-group">
          <div className="form-label">Hometown Ward</div>
          <div className="form-value"><span>*****</span></div>
        </div>
      </div>
    </div>
)}
